import { HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { NormalizedDistributionProduct } from '../../../../../../store/managementAnalysis/types';
import { CoesProductsQueryData } from '../../../../../../store/managementAnalysisDetails/selector';
import { IndicatorIcon } from '../../IndicatorIcon';
import { LateralProductBar } from '../../LateralProductBar';

import { tableHead } from './constants';

interface ProductSearchItemProps {
  item: Utils.ArrayElement<NonNullable<CoesProductsQueryData>>;
  product: NormalizedDistributionProduct;
}

const ProductSearchItem = ({ item, product }: ProductSearchItemProps) => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py={Spacing['stack.xxs']} px={Spacing['inline.xxxs']}>
      <LateralProductBar backgroundColor={Color[product.color]} />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.customerNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.assetNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.startDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.maturityDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{item.appliedValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{item.currentValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{item.markValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <HStack alignItems="center">
          <IndicatorIcon percentage={item.returnNormalized} />
          <TableContentItemText>{item.returnFormatted}</TableContentItemText>
        </HStack>
      </TableContentItemColumn>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
